export default __webpack_public_path__ + "static/media/13.809296c3.jpg";